enum WhatsAppStatus {
  NOT_SENT = "Not Sent",
  SENT = "Sent",
  DELIVERED = "Delivered",
  INTERESTED = "Interested",
  NOT_INTERESTED = "Not Interested",
}

export default WhatsAppStatus
